import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import styles from './BillingPeriod.module.scss';

type BillingPeriodProps = {
  startDate: Date;
  endDate: Date;
  className?: string;
  createdAt?: Date;
  testID?: string;
};

export const BillingPeriod: FC<BillingPeriodProps> = (props) => {
  const { className, createdAt, testID, startDate, endDate } = props;

  const { formatDate, formatMessage } = useIntl();

  const isLifetime = startDate?.getTime() === endDate?.getTime();

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className, 'p2')}
      data-section="billing-period"
    >
      {createdAt && (
        <div className={styles.date}>
          {formatMessage({
            id: 'subscription.createdAt',
            defaultMessage: 'Created at',
          })}
          {': '}
          <span className={styles.innerDate}>
            {formatDate(createdAt, {
              dateStyle: 'short',
            })}
          </span>
        </div>
      )}

      <div className={styles.date}>
        {formatMessage({
          id: 'global.startDate',
          defaultMessage: 'Start date',
        })}
        {': '}
        <span className={styles.innerDate}>
          {formatDate(startDate, {
            dateStyle: 'short',
          })}
        </span>
      </div>

      <div className={styles.date}>
        {formatMessage({
          id: 'global.endDate',
          defaultMessage: 'End date',
        })}
        {': '}
        <span className={styles.innerDate}>
          {isLifetime
            ? formatMessage({
                id: 'global.lifetime',
                defaultMessage: 'Lifetime',
              })
            : formatDate(endDate, {
                dateStyle: 'short',
              })}
        </span>
      </div>
    </div>
  );
};
